import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPower(n: number | null | undefined): string {
  if (n == null) return '—';
  return n.toFixed(1);
}

export function todayISO(): string {
  return new Date().toISOString().slice(0, 10);
}
